import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { TColumn } from '../../../columns/column.model';
import { GET_COLUMNS } from '../../../columns/columns.store';

export function checkColumnsToAdd({
  customFields,
  isOverview,
  existingColumns,
}: {
  customFields: TCustomField[];
  isOverview: boolean;
  existingColumns?: TColumn[];
}): TColumn[] {
  const columnsToAdd = [];
  const columnsToCheck = existingColumns ?? GET_COLUMNS();

  const visibleCustomFields = customFields.filter((customField) => customField.display);

  visibleCustomFields.forEach((customField) => {
    const column = columnsToCheck.find(
      (searchedColumn) => searchedColumn.name === customField.label,
    );

    if (!column) {
      columnsToAdd.push({
        name: customField.label,
        showTotal: customField.showTotal === true,
        customFieldIds: [customField.id.toString()],
        unit: customField.unit,
        decimalPlaces: customField.decimalPlaces,
        currency: customField.currencyCode,
        subValuesActive: customField.subValuesActive,
        hidden: isOverview,
      } as TColumn);
    }
  });

  return columnsToAdd;
}
